import React from "react";

const Rayhancar = () => {
  return (
    <div style={styles.container}>
      <h1 style={styles.title}>Privacy Policy</h1>
      <p style={styles.lastUpdated}>Last updated: March 10, 2025</p>

      <Section title="Overview">
        <p style={styles.body}>
          Rayhan Driving Center (“we”, “our”, “us”) operates this app to help
          learners manage training, attendance, and payments. This policy
          explains what we collect, why we collect it, and how we protect it.
        </p>
      </Section>

      <Section title="Information We Collect">
        <ul style={styles.body}>
          <li>Account: name, email, phone.</li>
          <li>Training: attendance, package, status.</li>
          <li>
            Payments: amounts paid and due (Cash on Delivery only, no online
            payments).
          </li>
          <li>Media: optional profile photo uploads.</li>
          <li>Device: push token for notifications.</li>
        </ul>
      </Section>

      <Section title="How We Use Information">
        <ul style={styles.body}>
          <li>Provide training services and scheduling.</li>
          <li>Track attendance and payments.</li>
          <li>Send notifications for attendance, due, and status updates.</li>
          <li>Improve safety and support.</li>
        </ul>
      </Section>

      <Section title="Sharing">
        <p style={styles.body}>
          We do not sell personal data. We share only with service providers
          needed to run the app (e.g., Firebase for auth, storage, messaging).
        </p>
      </Section>

      <Section title="Data Security">
        <p style={styles.body}>
          We use encryption in transit and restrict access to authorized staff.
          No system is 100% secure; contact us if you suspect an issue.
        </p>
      </Section>

      <Section title="Data Retention">
        <p style={styles.body}>
          We retain data while your account is active and for legal/operational
          needs. You may request deletion of your account and data.
        </p>
      </Section>

      <Section title="Your Choices">
        <ul style={styles.body}>
          <li>Update your profile details.</li>
          <li>Control notifications in device settings.</li>
          <li>Request data export or deletion.</li>
        </ul>
      </Section>

      <Section title="Children">
        <p style={styles.body}>
          This service is intended for adults. If you believe a minor’s data was
          collected, contact us to remove it.
        </p>
      </Section>

      <Section title="Contact">
        <p style={styles.body}>
          For privacy requests: nimcloudsystems@gmail.com
        </p>
      </Section>
    </div>
  );
};

const Section = ({ title, children }) => (
  <div style={styles.section}>
    <h3 style={styles.sectionTitle}>{title}</h3>
    {children}
  </div>
);

const styles = {
  container: {
    padding: "20px",
    backgroundColor: "#F8F8F8",
    gap: "16px",
  },
  title: {
    fontSize: "24px",
    fontWeight: "800",
    color: "#1C2C48",
  },
  lastUpdated: {
    fontSize: "12px",
    color: "#666",
  },
  section: {
    backgroundColor: "#fff",
    padding: "14px",
    borderRadius: "10px",
    border: "1px solid #E0E0E0",
    gap: "6px",
  },
  sectionTitle: {
    fontSize: "16px",
    fontWeight: "700",
    color: "#1C2C48",
  },
  body: {
    fontSize: "14px",
    color: "#444",
    lineHeight: "20px",
  },
};

export default Rayhancar;
